import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export type PhotoAuditEventType =
  | 'month_lock_overdue_override'
  | 'late_photo_upload'
  | 'gallery_upload_override'
  | 'confirm_without_photo';

export interface PhotoAuditEvent {
  id: string;
  eventType: PhotoAuditEventType;
  tripId: string | null;
  userId: string;
  reason: string | null;
  metadata: Record<string, unknown>;
  occurredAt: string;
  trip: { id: string; code: string; tripDate: string } | null;
  user: { id: string; code: string; fullNameEn: string; role: string };
}

export interface PhotoAuditListResponse {
  items: PhotoAuditEvent[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PhotoAuditListParams {
  eventType?: PhotoAuditEventType;
  userId?:    string;
  tripId?:    string;
  dateFrom?:  string;
  dateTo?:    string;
  page?:      number;
  pageSize?:  number;
}

export async function fetchAuditEvents(params: PhotoAuditListParams): Promise<PhotoAuditListResponse> {
  const { data } = await apiClient.get<PhotoAuditListResponse>('/api/v1/photo-audit', { params });
  return data;
}

export function usePhotoAudit(params: PhotoAuditListParams) {
  return useQuery({
    queryKey: ['photo-audit', params],
    queryFn:  () => fetchAuditEvents(params),
    placeholderData: (prev) => prev,
  });
}
